module.exports = __webpack_public_path__ + "img/pro_rcfw4.3c718599.png";